import * as React from 'react';
import '@grandvisionhq/common';
import '@grandvisionhq/state';
import '../../../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import '../../../selectors.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/locations';
import '../containers/PickupPointsFinderContainer.js';
import '../containers/StoresFinderContainer.js';
import { ShippingMethodsListContainer } from '../containers/ShippingMethodsListContainer.js';
import { SelectedShippingMethodContainer } from '../containers/SelectedShippingMethodContainer.js';

const ShippingMethods = ({ shippingMethodsAsides  })=>{
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-shipping-methods"
    }, /*#__PURE__*/ React.createElement(ShippingMethodsListContainer, {
        asides: shippingMethodsAsides
    })), /*#__PURE__*/ React.createElement(SelectedShippingMethodContainer, null));
};

export { ShippingMethods };
//# sourceMappingURL=ShippingMethods.js.map
